import axios from "axios";

const API = process.env.REACT_APP_API_URL;

// Returns active categories for public pages (Home, AddBusiness)
export const getCategories = async () => {
  const res = await axios.get(`${API}/categories`);
  return res.data;
};
